import React, { useState } from "react";

import CloseIcon from "@mui/icons-material/Close";

import { Box, Modal, Typography, Button, Container } from "@mui/material/";

import { SecondaryButton } from "../../../common/Buttons";
import { useTranslation } from "react-i18next";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 400,
  bgcolor: "background.paper",
  borderRadius: "15px",
  boxShadow: 24,
  p: 4,
  textAlign: "center",
  padding: "20px 20px",
  minWidth: 300,
};

function SharesModal({ handleClose }) {
  const { t } = useTranslation();
  return (
    <Modal
      keepMounted
      open={true}
      onClose={handleClose}
      aria-labelledby="keep-mounted-modal-title"
      aria-describedby="keep-mounted-modal-description"
    >
      <Container maxWidth="xs">
        <Box sx={style}>
          <Typography sx={{ textAlign: "right", cursor: "pointer" }}>
            <CloseIcon onClick={handleClose} />
          </Typography>

          <Typography
            id="keep-mounted-modal-description"
            px={5}
            py={2}
            sx={{ mt: 2 }}
          >
            {t("shares-adjust-txt1")} <br />
            {t("shares-adjust-txt2")}
          </Typography>
          <Typography sx={{ mt: 8 }}>
            <SecondaryButton
              title={t("ok")}
              textTransform="initial"
              width={false}
              padding="0.25rem 3rem"
              border="2px solid #C498BB40"
              borderRadius={2}
              fontSize="0.85rem"
              fontWeight="500"
              marginTop="4px"
              click={handleClose}
            />
          </Typography>
        </Box>
      </Container>
    </Modal>
  );
}
export default SharesModal;
